export const operationalTierMap = {
  nonFunctional: {
    name: 'Non-Functional',
    features: ['This agent is not available for use or has not been built yet'],
  },
  generalLogin: {
    name: 'General login',
    features: [],
  },
  clerical: {
    name: 'Clerical',
    features: [
      'Advanced authentication flows including MFA support',
      'Save Future Capital phone functionality',
      'Fund linup downloads (including fact sheets)',
    ],
  },
  expandedInformation: {
    name: 'Expanded Information',
    features: ['Download holdings', 'Download transactions'],
  },
  advancedOperations: {
    name: 'Advanced Operations',
    features: ['Rebalance portfolio', 'Set future elections'],
  },
};

export const andromedaAgentOperationalTiers = {
  nonFunctional: 'nonFunctional',
  generalLogin: 'generalLogin',
  clerical: 'clerical',
  expandedInformation: 'expandedInformation',
  advancedOperations: 'advancedOperations',
};
